export default "__VITE_ASSET__pSx$HTN2__"